import React, { useState } from "react";
import ENOFrontiersGraph from "../WidgetGraphs/ENOFrontiersGraph";
import styles from "./style.module.scss";
import EnergyDeltaGraph from "../WidgetGraphs/EnergyDeltaGraph";
import GPSTrackMap from "../../Timing/GPSTrackMap";
import PitLossLine from "../../Timing/PitLossGraphs/PitLossLine";
import PitLossScatter from "../../Timing/PitLossGraphs/PitLossScatter";
import {
  getGraphSelectionPreference,
  setGraphSelectionPreference,
} from "../../../utils/preferences";
import SoCGraph from "../WidgetGraphs/SoCGraph";
import TCellGraph from "../WidgetGraphs/TCellGraph";
import LiveAttackExpiry from "../LiveAttackExpiry";

export default function GraphSwitcher({
  carColour,
  id,
}: {
  carColour: string;
  id: number;
}) {
  const GRAPH_OPTIONS = [
    {
      component: <EnergyDeltaGraph carColour={carColour} />,
      label: "Energy Delta",
    },
    {
      component: <GPSTrackMap raceMode carColour={carColour} />,
      label: "Track Map",
    },
    {
      component: <LiveAttackExpiry carColour={carColour} />,
      label: "Attack Expiry",
    },
    {
      component: <PitLossLine />,
      label: "Pit Loss Line",
    },
    {
      component: <PitLossScatter />,
      label: "Pit Loss Scatter",
    },
    {
      component: <SoCGraph carColour={carColour} />,
      label: "SoC",
    },
    {
      component: <TCellGraph carColour={carColour} />,
      label: "TCell Max",
    },
    {
      component: <ENOFrontiersGraph carColour={carColour} />,
      label: "ENO Frontiers",
    },
  ] as const;

  const [selectedLabel, setSelectedLabel] = useState<string>(
    () =>
      getGraphSelectionPreference(id) ||
      GRAPH_OPTIONS[(id - 1) % GRAPH_OPTIONS.length].label,
  );

  const selectedOption =
    GRAPH_OPTIONS.find((option) => option.label === selectedLabel) ??
    GRAPH_OPTIONS[0];

  const handleChange = (label: string) => {
    setSelectedLabel(label);
    setGraphSelectionPreference(id, label);
  };

  return (
    <div className={styles.container}>
      <select
        className={styles.selector}
        value={selectedLabel}
        onChange={(e) => handleChange(e.target.value)}
      >
        {GRAPH_OPTIONS.map((option) => (
          <option key={option.label} value={option.label}>
            {option.label}
          </option>
        ))}
      </select>
      {selectedOption.component}
    </div>
  );
}
